<style lang="scss" scoped>
</style>
<template>
  <div>
    <headerIndex
      v-on:grid="currentView='grid'"
      v-on:list="currentView='list'"
      v-on:map="currentView='map'"
    ></headerIndex>
    <template v-if="currentView == 'list' && path == '/co'">
      <co2List></co2List>
    </template>
    <template v-if="currentView == 'grid' && path == '/co'">
      <co2Grid></co2Grid>
    </template>
    <template v-if="currentView == 'map' && path == '/co'">
      <co2Map/>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    headerIndex: () => import('@/components/headerIndex/headerIndex.vue'),
    co2List: () => import('./List.vue'),
    co2Grid: () => import('./Grid.vue'),
    co2Map: () => import('./Map.vue')
  },
  data () {
    return {
      currentView: 'list',
      path: ''
    }
  },
  created () {
    this.path = this.$route.path
  }
}
</script>
